// Fix for video-media elements to work with current theme's DeferredMedia system
document.addEventListener('DOMContentLoaded', function() {
  // Fix video-media elements that don't have the expected poster ID
  const videoMediaElements = document.querySelectorAll('video-media.deferred-media');
  
  videoMediaElements.forEach((element, index) => {
    const posterImage = element.querySelector('img');
    
    // If the poster doesn't have the expected ID, add it
    if (posterImage && !posterImage.id.startsWith('DeferredPoster-')) {
      posterImage.id = `DeferredPoster-VideoMedia-${index}`;
    }
    
    // Add click handler to load video content
    if (posterImage && element.querySelector('template')) {
      posterImage.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        // Load the video using the template
        const template = element.querySelector('template');
        if (template && !element.hasAttribute('data-media-loaded')) {
          const content = template.content.firstElementChild?.cloneNode(true);
          if (content) {
            element.setAttribute('data-media-loaded', 'true');
            element.setAttribute('playing', '');
            posterImage.replaceWith(content);
            
            // Try to play the video
            if (content.tagName === 'VIDEO') {
              content.play().catch(e => {
                console.log('Video autoplay blocked:', e);
                content.controls = true;
              });
            }
          }
        }
      });
    }
  });
});